module.exports = __webpack_public_path__ + "static/img/fwzc_01.593052d.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_01.png
// module id = 0yPT
// module chunks = 2